/**
 * `tpoPricing` / product_rates use specific subclass labels. The extend flow and Core
 * inference often surface the generic "Motor Commercial" bucket. Map it to a 1Y TPO row
 * that uses the same tonnage bands (aligned with General Cartage / Own Goods pricing).
 */
export function tpoPricingLookupLabel(selectedClass) {
  if (selectedClass === 'Motor Commercial') return 'Motor Commercial General Cartage';
  return selectedClass;
}
